import { render, staticRenderFns } from "./CategoriasDetail.vue?vue&type=template&id=30ab1309&"
import script from "./CategoriasDetail.vue?vue&type=script&lang=js&"
export * from "./CategoriasDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports